(function() {
var TermsWizardForm,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

TermsWizardForm = (function() {
  function TermsWizardForm(form_containter, form_selector) {
    this.submit_form = bind(this.submit_form, this);
    this.show_step = bind(this.show_step, this);
    var i, len, ref, step, step_element;
    this.form_selector = form_selector;
    this.form_containter = form_containter;
    this.step_elements = this.form_containter.find("[data-wizard-step]");
    this.num_steps = this.step_elements.length;
    this.steps = {};
    ref = this.step_elements;
    for (i = 0, len = ref.length; i < len; i++) {
      step_element = ref[i];
      step = $(step_element);
      this.steps[step.data("wizard-index")] = step;
    }
    $(document).on("click", "[data-wizard-accept]", (function(_this) {
      return function(e) {
        return _this.accept_clicked(e);
      };
    })(this));
    $(document).on("click", "[data-wizard-reject]", (function(_this) {
      return function(e) {
        return _this.reject_clicked(e);
      };
    })(this));
    this.current_index = 1;
    this.show_step();
  }

  TermsWizardForm.prototype.accept_clicked = function(e) {
    var $button, $wizard_step, terms_name;
    e.preventDefault();
    $button = $(e.target);
    terms_name = $button.data("wizard-accept");
    $("#terms_consent_" + terms_name).val("accept");
    $wizard_step = $button.closest("[data-wizard-step]");
    $button.removeClass("btn-primary").addClass("btn-success");
    if (terms_name === "marketing") {
      $wizard_step.find("[data-wizard-reject]").removeClass("btn-danger").addClass("btn-default");
    }
    return this.next_step($wizard_step);
  };

  TermsWizardForm.prototype.reject_clicked = function(e) {
    var $button, $wizard_step, terms_name;
    e.preventDefault();
    $button = $(e.target);
    terms_name = $button.data("wizard-reject");
    $("#terms_consent_" + terms_name).val("reject");
    $wizard_step = $button.closest("[data-wizard-step]");
    $button.removeClass("btn-default").addClass("btn-danger");
    if (terms_name === "marketing") {
      $wizard_step.find("[data-wizard-accept]").removeClass("btn-primary btn-success").addClass("btn-default");
    }
    return this.next_step($wizard_step);
  };

  TermsWizardForm.prototype.next_step = function(current_wizard_step) {
    var _wizard_index;
    if (this.current_index < this.num_steps) {
      this.current_index += 1;
    }
    _wizard_index = current_wizard_step.data("wizard-index");
    if (_wizard_index === this.num_steps) {
      return this.submit_form();
    } else if (this.current_index <= this.num_steps) {
      return this.show_step();
    }
  };

  TermsWizardForm.prototype.show_step = function() {
    var height;
    this.steps[this.current_index].show();
    height = this.form_containter[0].scrollHeight;
    return $('html, body').animate({
      scrollTop: height
    }, 'slow');
  };

  TermsWizardForm.prototype.submit_form = function() {
    return this.form_containter.find("form").submit();
  };

  return TermsWizardForm;

})();

jQuery(function() {
  var $terms_wizard_form_el;
  $terms_wizard_form_el = $("#terms_wizard_form");
  if ($terms_wizard_form_el.length > 0) {
    return this.terms_wizard_form = new TermsWizardForm($terms_wizard_form_el, "#terms_wizard_form");
  }
});

}).call(window);
